import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import Loader from "../../../components/Loader";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import Table from "../../../components/Table";
import { EquipementscolumnsEvoko } from "../../../components/headerContent";
import NumberCard from "../../../components/Card/NumberCard";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function EquipementEvoko() {
  const { apiUrl, user } = useContext(AuthContext);
  const { t, i18n } = useTranslation();
  const [filteredData, setFilteredData] = useState([]);

  const getEquipementsEvoko = async () => {
    const res = await axios.get(`${apiUrl}evoko/devices`, {
      withCredentials: true,
    });
    return res.data;
  };

  const EquipementsEvoko = useQuery({
    queryKey: ["EquipementsEvoko"],
    queryFn: getEquipementsEvoko
  });

  useEffect(() => {
    if (!EquipementsEvoko.isFetching && EquipementsEvoko.data && EquipementsEvoko.data.devices.length > 0) {
      setFilteredData(EquipementsEvoko.data.devices);
    }
  }, [EquipementsEvoko]);

  if (!EquipementsEvoko.isLoading && EquipementsEvoko.data && EquipementsEvoko.data.length === 0 || !EquipementsEvoko.isLoading && !EquipementsEvoko.data) {
    return (
      <div className="ecp-container">
        <div className="ecp-container-content-error">
          <div className="error-container">
            <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
            <div className="error-container-text">
              <h1 className="page-title">
                {t("Aucun équipement disponible")}
              </h1>
              <p className="page-link_home">
                <Link to="/"> {t("Revenir à l'accueil")}</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ecp-container">
      <div className="ecp-container-content">
        {!EquipementsEvoko.isLoading && !EquipementsEvoko.isFetching ? (
          <>
            <div className="ecp-container-content-header">
              <div className="ecp-container-content-header-title">
                <div className="page-title page-logo">
                  <img src="../assets/evoko.png" alt="Logo de Cisco Webex" />
                  <h1 className="page-title">{t("Equipements")} Evoko</h1>
                </div>
              </div>
            </div>
            <section className="page-section">
              <NumberCard
                title={`${t("Nombre d'équipements disponibles")}`}
                number={
                  filteredData.length
                }
                logo={faCircleCheck}
                color={"#AEC353"}
                stylesIcons={"logo-certificats"}
              />
            </section>
            <div className='cato-content-table'>
              <Table
                tableData={
                  filteredData
                }
                tableColumns={EquipementscolumnsEvoko}
                sites={filteredData}
                holding={user.entrepriseId}
              />
            </div>
          </>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}
